import { render } from "./EmailAttachmentButton.vue?vue&type=template&id=91be214a&scoped=true"
import script from "./EmailAttachmentButton.vue?vue&type=script&lang=js"
export * from "./EmailAttachmentButton.vue?vue&type=script&lang=js"

import "./EmailAttachmentButton.vue?vue&type=style&index=0&id=91be214a&scoped=true&lang=scss"

import exportComponent from "/var/www/html/vg.carvex.ee/frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-91be214a"]])

export default __exports__